module.exports = __webpack_public_path__ + "static/0092-4cd5c2ed7946fc52f562b479cf78d97a.png";